module.exports = __webpack_public_path__ + "static/media/arrow-dropdown.3034a3fd.svg";